import { useEffect } from 'react';
import PropTypes from 'prop-types';

import './DefaultLayout.css';

import TopMenu from '../elements/TopMenu/TopMenu';
import Footer from '../elements/Footer/Footer';

/**
 * Default page layout
 * @component
 */
const DefaultLayout = ({ title, children }) => {
	useEffect(() => {
		document.title = title + ' | MTG Keeper';
	}, [title]);

	return (
		<div className="default-layout">
			<TopMenu />
			<div className="layout-workspace">{children}</div>
			<Footer />
		</div>
	);
};

DefaultLayout.propTypes = {
	// Page title for the browser tab
	title: PropTypes.string.isRequired,
	// Page Layout
	children: PropTypes.node.isRequired,
};

export default DefaultLayout;
